import {Button} from 'brand/Button'

const smokeyDescription = 'A great nighttime look with splashes of purple and warm smokey tones'
const addProductsBlurb = 'Add products from your makeup bag and see what you can use instead.'

const foundationSplodge = 'https://png.pngtree.com/png-vector/20220530/ourmid/pngtree-cosmetic-foundation-cream-bottle-png-image_4762844.png'


export const TabAbout = ({products}) => (
  products.length === 0 ? null :
  <>
    <section>
      <div className="heading size-l">About this look</div>
      <div className="content size-m">{smokeyDescription}</div>
    </section>
    <section>
      <div className="heading size-m">Palette</div>
      <ProductSwatchPalette colours={flattenColours(products)} />
    </section>
    <section>
      <div className="heading size-m">For this look you'll need</div>
      {products.map(({productId, type, name, assetUrl}) => (
        <ProductTile
          category={type}
          name={name}
          thumbnailUrl={assetUrl ?? foundationSplodge}
          key={productId}
        />
      ))}
    </section>
    <section>
      <div className="heading size-l">Have products already?</div>
      <div className="content size-m">{addProductsBlurb}</div>
      <div className="content"><Button>Add your makeup bag</Button></div>
    </section>
  </>
)

const ProductSwatchPalette = ({colours}) => (
  <div className="content palette">
    {colours.map((it) =>
      <span className="swatch" style={{backgroundColor: it}} key={it} />
    )}
  </div>
)

const ProductTile = ({category, name, thumbnailUrl}) => (
  <div className="product-tile">
    <img alt={`Product thumbnail for ${name}`} src={thumbnailUrl} />
    <div className="details">
      <div className="category size-s">{category}</div>
      <div className="name size-m">{name}</div>
    </div>
    <button className="view-alt size-xs">View Alternative</button>
  </div>
)

const flattenColours = products => {
  const allColours = products
    .map(p => p.colours)
    .map(({data, render}) => {
      const d = data ?? undefined
      const r = render?.colour ?? undefined
      const m1 = render?.material?.color1 ?? undefined
      const m2 = render?.material?.color2 ?? undefined
      return [d, r, m1, m2].filter(it => it !== undefined)
    }).flat().flat()
  const uniqueColours = [...new Set(allColours.map(rgbaToHexColour))]
  return uniqueColours
}

const rgbaToHexColour = ({r, g, b, a}) => {
  const hexChannels = [r, g, b, Math.floor(a * 255)]
    .map(c => c.toString(16).padStart(2, '0'))
  return ['#', ...hexChannels].join('')
}
